/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import TextWidget from './TextWidget';
import {
  preventSpecialCharsAtBeginningInput,
  preventSpecialCharsAtBeginningInputOnPaste,
} from '../../../shared/utils/stringUtils';
import { uiSchemaProperties } from '../../../shared/enums/uiSchemaProperties';

export default function TypicalTextAreaWidget(props) {
  const { options, uiSchema, rawErrors = [], rawHelp = [] } = props;

  const _onKeyDown = (e) => {
    preventSpecialCharsAtBeginningInput(e);
  };

  const _onPaste = (e) => {
    preventSpecialCharsAtBeginningInputOnPaste(e);
  };

  const hasError = rawErrors?.length > 0 || uiSchema?.[uiSchemaProperties.UI_HELP_SEVERITY] === 'error';
  const hasWarning = rawHelp?.length > 0 && uiSchema?.[uiSchemaProperties.UI_HELP_SEVERITY] === 'info';

  return (
    <TextWidget
      multiline={true}
      onKeyDown={_onKeyDown}
      onPaste={_onPaste}
      minRows={options?.rows || 5}
      {...props}
      hasError={hasError}
      hasWarning={hasWarning}
    />
  );
}
